import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { API } from "../constant";
import logo3 from "../Media/LogoReverseWithTag.svg";
import Loading from "../Components/Hooks/Loading";

const RegisterIntro = () => {
    const [logoUrl, setLogoUrl] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(`${API}/app-information?populate=*`)
            .then(res => {
                if (!res.ok) throw new Error();
                return res.json();
            })
            .then(data => {
                setLogoUrl(data.data.attributes.logo_3?.data?.attributes?.url || null);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, []);

    if (loading) return <Loading />;

    return (
        <div className="app-inner welcome register-intro">
            <div className="container">
                <div className="content-wrap bg-blue">
                    <div className="welcome-box">

                        <div className="logo mb---20 fade-in-down">
                            <img src={logoUrl || logo3} alt="CopeAhead" />
                        </div>

                        <p className="register-intro-tagline fade-in-down delay-1">
                            For less than a copay, get access to interactive DBT skills to help calm down quickly, learn skills for managing distress, and CopeAhead.
                        </p>

                        <div className="register-intro-pricing fade-in-down delay-1">
                            <div className="pricing-row">
                                <span className="pricing-amount">$2.99</span>
                                <span className="pricing-period">PM</span>
                                <span className="pricing-amount">/ $32</span>
                                <span className="pricing-period">Year</span>
                                <span className="pricing-badge">Billed Annually</span>
                            </div>
                            
                        </div>

                        <div className="btn btn-gradient btn-full btn-white mb---10 btn-center delay-2">
                            <Link to="/register">Register Now</Link>
                        </div>

                        <div className="btn btn-link btn-full btn-large btn-white mt---10 btn-center delay-2">
                            <Link to="/Login">Already have an account? Log in</Link>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegisterIntro;
